import styled, { StyledComponentPropsWithRef } from 'styled-components'

import { ReactComponent as ArrowDownSvg } from '../../assets/icons/arrow-down.svg'
import { ReactComponent as ArrowSvg } from '../../assets/icons/arrow.svg'
import { ReactComponent as VehicleSvg } from '../../assets/icons/vehicle.svg'
import { ReactComponent as BellSvg } from '../../assets/icons/bell.svg'
import { ReactComponent as CalendarSvg } from '../../assets/icons/calendar.svg'
import { ReactComponent as CancelCrossSvg } from '../../assets/icons/cancel-cross.svg'
import { ReactComponent as CopySvg } from '../../assets/icons/copy.svg'
import { ReactComponent as ChecklistReportSvg } from '../../assets/icons/checklist-report.svg'
import { ReactComponent as ChecklistSvg } from '../../assets/icons/checklist.svg'
import { ReactComponent as CheckCircleSvg } from '../../assets/icons/check-circle.svg'
import { ReactComponent as CheckmarkSvg } from '../../assets/icons/checkmark.svg'
import { ReactComponent as RadioButtonSvg } from '../../assets/icons/radiobutton.svg'
import { ReactComponent as ChevronSvg } from '../../assets/icons/chevron.svg'
import { ReactComponent as ClockSvg } from '../../assets/icons/clock.svg'
import { ReactComponent as DashSvg } from '../../assets/icons/dash.svg'
import { ReactComponent as DiscrepancyReportSvg } from '../../assets/icons/discrepancy-report-icon.svg'
import { ReactComponent as DotsSvg } from '../../assets/icons/dots.svg'
import { ReactComponent as DownloadSvg } from '../../assets/icons/download.svg'
import { ReactComponent as DragCrossSvg } from '../../assets/icons/drag-cross.svg'
import { ReactComponent as ErrorSvg } from '../../assets/icons/error.svg'
import { ReactComponent as EmailSvg } from '../../assets/icons/email.svg'
import { ReactComponent as ExclamationMarkSmallSvg } from '../../assets/icons/exclamation-mark--small.svg'
import { ReactComponent as ExclamationMarkSvg } from '../../assets/icons/exclamation-mark.svg'
import { ReactComponent as FilterSvg } from '../../assets/icons/filter.svg'
import { ReactComponent as FlightNetworkSvg } from '../../assets/icons/flight-network.svg'
import { ReactComponent as DeliveryPointNodeSvg } from '../../assets/icons/flight-network/delivery-point-node.svg'
import { ReactComponent as LaunchpadNodeSvg } from '../../assets/icons/flight-network/launchpad-node.svg'
import { ReactComponent as SemaphoreNodeSvg } from '../../assets/icons/flight-network/semaphore-node.svg'
import { ReactComponent as WaypointNodeSvg } from '../../assets/icons/flight-network/waypoint-node.svg'
import { ReactComponent as FlytrexLogoFirstLetterSvg } from '../../assets/icons/flytrex-logo-first-letter.svg'
import { ReactComponent as FlytrexLogoSmallSvg } from '../../assets/icons/flytrex-logo-small.svg'
import { ReactComponent as FromToSvg } from '../../assets/icons/from-to.svg'
import { ReactComponent as GearSvg } from '../../assets/icons/gear.svg'
import { ReactComponent as HammerSvg } from '../../assets/icons/hammer.svg'
import { ReactComponent as LogoutSvg } from '../../assets/icons/logout.svg'
import { ReactComponent as MagnifyingGlassSvg } from '../../assets/icons/magnifying-glass.svg'
import { ReactComponent as ManualSvg } from '../../assets/icons/manual.svg'
import { ReactComponent as MissionNoteSvg } from '../../assets/icons/mission-note.svg'
import { ReactComponent as OktaSvg } from '../../assets/icons/okta.svg'
import { ReactComponent as PersonProfileSvg } from '../../assets/icons/person-profile.svg'
import { ReactComponent as PlusSvg } from '../../assets/icons/plus.svg'
import { ReactComponent as PropellorSvg } from '../../assets/icons/propellor.svg'
import { ReactComponent as RoleSvg } from '../../assets/icons/role.svg'
import { ReactComponent as TimesMarkSmallSvg } from '../../assets/icons/times-mark--small.svg'
import { ReactComponent as TrashcanSvg } from '../../assets/icons/trashcan.svg'
import { ReactComponent as UserInfoSvg } from '../../assets/icons/user-info.svg'
import { ReactComponent as UserLargeSvg } from '../../assets/icons/user-large.svg'
import { ReactComponent as UserSvg } from '../../assets/icons/user.svg'
import { ReactComponent as WifiSvg } from '../../assets/icons/wifi.svg'
import { ReactComponent as WrenchSvg } from '../../assets/icons/wrench.svg'
import { ReactComponent as LaunchpadsSvg } from '../../assets/icons/launchpads.svg'
import { ReactComponent as LargeDroneSvg } from '../../assets/icons/large-drone.svg'
import { ReactComponent as VehicleParkedSvg } from '../../assets/icons/vehicle-parked.svg'
import { ReactComponent as VehicleWarningSvg } from '../../assets/icons/vehicle-warning.svg'
import { ReactComponent as VehicleErrorSvg } from '../../assets/icons/vehicle-error.svg'
import { ReactComponent as StatusSvg } from '../../assets/icons/status.svg'

import { ReactComponent as AboutSvg } from '../../assets/icons/about.svg'

import { ReactComponent as PencilSvg } from '../../assets/icons/pencil.svg'

import { ReactComponent as StylusSvg } from '../../assets/icons/stylus.svg'
import { ReactComponent as HandSvg } from '../../assets/icons/hand.svg'
import { ReactComponent as RulerSvg } from '../../assets/icons/ruler.svg'
import { ReactComponent as PolylineSvg } from '../../assets/icons/polyline.svg'
import { ReactComponent as PolylineCursorSvg } from '../../assets/icons/polyline-cursor.svg'

import { theme, type ColorValue } from '../../styles/theme'

import type { ComponentProps } from 'react'
import { svgIconHoverClassName, svgNoShrinkClassName } from '../../styles/globalCss'

export interface MaybeWithSize {
  size?: number | string
}


export function withSvgIconClassName<Props>(props: Props & MaybeWithClassName & MaybeWithSize) {
  // Order matters!
  return { ...props, className: `${svgIconHoverClassName} ${props.className ?? ''}` }
}

export function withSvgNoShrinkClassName() {
  return { className: svgNoShrinkClassName }
}

type SvgComponentProps = StyledComponentPropsWithRef<typeof TrashcanSvg>
const Trashcan = (props: SvgComponentProps) => <TrashcanSvg {...withSvgIconClassName(props)} />

export type IconType = typeof Trashcan & WithDisplayName & MaybeWithSize
export interface IconProps extends ComponentProps<IconType> {}

export type SvgType = typeof TrashcanSvg

export const SvgIcons = {
  ArrowSvg,
  VehicleSvg,
  RadioButtonSvg,
  ArrowDownSvg,
  ClockSvg,
  ChecklistReportSvg,
  CancelCrossSvg,
  CalendarSvg,
  CopySvg,
  DragCrossSvg,
  ErrorSvg,
  EmailSvg,
  FilterSvg,
  DownloadSvg,
  DiscrepancyReportSvg,
  FlightNetworkSvg,
  FromToSvg,
  GearSvg,
  PropellorSvg,
  HammerSvg,
  ChecklistSvg,
  CheckCircleSvg,
  ManualSvg,
  UserSvg,
  UserLargeSvg,
  MagnifyingGlassSvg,
  MissionNoteSvg,
  PlusSvg,
  RoleSvg,
  StatusSvg,
  ChevronSvg,
  FlytrexLogoFirstLetterSvg,
  FlytrexLogoSmallSvg,
  PencilSvg,
  TrashcanSvg,
  OktaSvg,
  UserInfoSvg,
  LogoutSvg,
  LaunchpadsSvg,
  LargeDroneSvg,
  VehicleParkedSvg, 
  VehicleWarningSvg,
  VehicleErrorSvg,
  AboutSvg,
  StylusSvg,
  HandSvg,
  RulerSvg,
  PolylineSvg,
  CheckmarkSvg,

  WaypointNodeSvg,
  SemaphoreNodeSvg,
  DeliveryPointNodeSvg,
  LaunchpadNodeSvg,
  PolylineCursorSvg,
}

/**
 * To set the color, make sure the source SVG icon file has no `"fill"` or `"stroke"` attributes.__
 *
 * - Use a `color` attribute on the SVG element
 *
 * **OR**
 *
 * - Use a `--color` CSS variable.
 *
 * **OR**
 *
 * - The color will implicitly cascade via CSS using the `currentColor` value.
 * - Use `--size` CSS variable to set the size.
 */
export const TrashcanIcon = styled(Trashcan)
  .attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  stroke: none;
`

export const FlytrexLogoFirstLetterIcon = styled((props: IconProps) => (
  <FlytrexLogoFirstLetterSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  stroke: none;
`

// Wrapped in styled in order to allow interpolation in other Linaria components. Won't work otherwise.
export const ChevronIcon = styled((props: IconProps) => <ChevronSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>``

export const ChevronThinIcon = styled(ChevronIcon)
  .attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  transform: rotate(-90deg);
  stroke: none;
`

export const PlusIcon = styled((props: IconProps) => <PlusSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  stroke: none;
`

export const CheckmarkIcon = styled((props: IconProps) => <CheckmarkSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  /* The icon contents aren't a square :/ */
  overflow: visible;
  stroke: none;
`

export const DashIcon = (props: IconProps) => <DashSvg {...withSvgIconClassName(props)} />

export const WifiIcon = styled((props: IconProps) => <WifiSvg {...withSvgIconClassName(props)} />)`
  overflow: visible;
  stroke: none;
`

export const ExclamationMarkIcon = styled((props: IconProps) => (
  <ExclamationMarkSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  fill: ${theme.colors.Red};
  /* TODO: switch to named color */
  stroke: #2d353f;
`

export const PersonProfileIcon = styled((props: IconProps) => (
  <PersonProfileSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  stroke: none;
`

export const WrenchIcon = styled((props: IconProps) => <WrenchSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  overflow: visible;
  stroke: none;
`

export const BellIcon = styled((props: IconProps) => <BellSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  overflow: visible;
  stroke: none;
`

export const DotsIcon = styled((props: IconProps) => <DotsSvg {...withSvgIconClassName(props)} />)
  .attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  overflow: visible;
`

export const MagnifyingGlassIcon = styled((props: IconProps) => (
  <MagnifyingGlassSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>``

const StatusDot = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: var(--size, 1em);
  flex-shrink: 1;
  ::before {
    content: '';
    flex-shrink: 0;
    border-radius: 50%;
    background-color: var(--color, currentColor);
    /* Sizes override 'min-' sizes */
    block-size: var(--size, 0.7em);
    inline-size: var(--size, 0.7em);
  }
`

export const SmallExclamationMarkIcon = styled((props: IconProps) => (
  <ExclamationMarkSmallSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  fill: var(--color, currentColor);
  stroke: ${theme.colors.White};
`

export const SmallTimesMarkIcon = styled((props: IconProps) => (
  <TimesMarkSmallSvg {...withSvgIconClassName(props)} />
)).attrs((props: IconType)=>({ name: props.name, displayName: props.displayName }))<IconType>`
  fill: var(--color, currentColor);
  stroke: ${theme.colors.White};
`

const StatusDotText = styled.span`
  flex-shrink: 1;
`

export interface ColorWithText extends WithText {
  color: ColorValue
}

interface StatusDotIconProps extends Omit<StyledComponentPropsWithRef<typeof StatusDot>, 'color'>, ColorWithText {}

export function StatusDotIcon({ color, text, title = text, children, ...props }: StatusDotIconProps) {
  return (
    <StatusDot
      {...({ style: { ...props['style'], '--color': color }, title, ...props } as WithStyle)}
    >
      {children ?? <StatusDotText {...{ children: text }} />}
    </StatusDot>
  )
}
